<template>
  <div class="header" id="header" :style="headerStyle">
    <!-- 顶部主区域 (60px) -->
    <div class="top">
      <!-- 左容器：诊所名称 -->
      <div class="left-container">
        <div class="logo-and-expire">
          <div class="logo-part">
            <span class="app-title">
              <i class="el-icon-mzgh" style="margin-right: 8px; font-size: 24px;"></i>
              {{ displayDocName || '九阵数字云诊所' }}
            </span>
          </div>
          <div class="expire-part" v-if="userinfo && userinfo.userId !== 1 && expireInfo.show">
            <span class="expire-days" :class="{ 'expire-warning': expireInfo.isExpiringSoon }">
              ({{ expireInfo.daysRemaining > 0 ? '剩余' + expireInfo.daysRemaining + '天' : '已过期' }})
            </span>
          </div>
        </div>
      </div>

      <!-- 中间容器：当前时间日期 -->
      <div class="middle-container time-container">
        <div class="time-display">
          <div class="time">{{ currentTime }}</div>
          <div class="date">{{ currentDate }}</div>
        </div>
      </div>

      <!-- 右容器：角色下拉、重置数据、用户信息 -->
      <div class="right-container">
        <!-- 角色切换下拉菜单 (PC端显示) -->
        <div class="role-dropdown pc-only" v-if="userRolesList.length > 0">
          <el-dropdown trigger="click" @command="handleRoleCommand">
            <span class="role-btn">
              {{ currentRoleName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(role, index) in userRolesList" :key="index" :command="role">
                {{ role.roleName || role.name || role }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <!-- 帮助与菜单树切换 (PC端显示) -->
        <div class="mode-dropdown pc-only">
          <span class="mode-button help-button" @click="handleHelpCenter">
            <i class="el-icon-question" style="margin-right: 4px;"></i>
            帮助中心
          </span>
        </div>
        <div class="mode-dropdown pc-only">
          <el-dropdown trigger="hover" @command="handleModeCommand">
            <span class="el-dropdown-link mode-button">
              <i class="el-icon-refresh"></i> 菜单树
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="tree" :class="{ 'is-active': menuMode === 'tree' }">
                菜单树
              </el-dropdown-item>
              <el-dropdown-item command="flow" disabled>
                标准流程图
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <!-- 当前用户信息下拉 (动态切换触发方式：PC hover / 移动端 click) -->
        <div class="user-info">
          <el-dropdown 
            @command="HandleCommand" 
            :trigger="isMobile ? 'click' : 'hover'" 
            style="cursor: pointer;"
          >
            <span class="el-dropdown-link">
              <el-avatar :size="32" src="" style="margin-right: 8px;" class="user-avatar">
                {{ staffName ? staffName.charAt(0) : 'U' }}
              </el-avatar>
              <span class="user-name" style="margin-right: 8px;">{{ staffName }}</span>
              <i class="el-icon-arrow-down mobile-arrow" v-if="isMobile"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              
              <!-- 移动端专属：角色切换组 -->
              <template v-if="isMobile">
                <el-dropdown-item disabled class="dropdown-group-title">
                  切换角色
                </el-dropdown-item>
                <el-dropdown-item 
                  v-for="(role, index) in userRolesList" 
                  :key="'role-'+index"
                  :command="'role-' + index"
                  :class="{ 'is-active': currentRoleName === (role.roleName || role.name || role) }"
                >
                  {{ role.roleName || role.name || role }}
                </el-dropdown-item>
                
                <el-dropdown-item divided command="help">
                  <i class="el-icon-question" style="margin-right: 8px;"></i>帮助中心
                </el-dropdown-item>
                <el-dropdown-item command="menuTree">
                  <i class="el-icon-menu" style="margin-right: 8px;"></i>菜单树
                </el-dropdown-item>
                <el-dropdown-item divided command="userinfo">
                  <i class="el-icon-user" style="margin-right: 8px;"></i>个人中心
                </el-dropdown-item>
              </template>

              <!-- PC端专属：个人中心 -->
              <template v-else>
                <el-dropdown-item command="userinfo">个人中心</el-dropdown-item>
              </template>

              <!-- 通用组 -->
              <el-dropdown-item command="changeDept">切换科室</el-dropdown-item>
              <el-dropdown-item command="clearCache">清理缓存</el-dropdown-item>
              <el-dropdown-item command="loginout" divided>退出系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 右键菜单 -->
    <context-menu :visible="contextMenu.visible" :position="contextMenu.position"
                  :current-tab="contextMenu.currentTab" :current-index="contextMenu.currentIndex" :tabs="editableTabs"
                  @close="hideContextMenu" @close-current="handleCloseCurrent" @close-right="handleCloseRight"
                  @close-left="handleCloseLeft" @close-all="handleCloseAll">
    </context-menu>

    <!-- 切换科室对话框 -->
    <el-dialog :modal="false" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false"
               title="选择科室" :visible.sync="selDeptDialogVisible" :before-close="handleBeforeClose" width="20%">
      <el-form size="mini" label-width="100px" ref="deptForm" :model="selDeptForm">
        <el-row>
          <el-col :span="24">
            <el-form-item :model="selDeptForm" label="选择科室:">
              <el-select filterable v-model="selDeptForm.deptId" style="width: 60%" placeholder="请选择科室">
                <el-option v-for="item in deptOptions" :key="item.id" :label="item.label"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer no-line">
        <el-button type="primary" @click="handleChekedDept" :disabled="!selDeptForm.deptId" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {EventBus} from '../../../src/directive/event-bus.js';
import watermark from "@/untils/watermark";
import {loginOut, searchUserMenu} from "@/api/user.js";
import {docclinic} from "@/api/cinic/cinic.js";

export default {
  data() {
    return {
      displayDocName: '',
      staffName: 'admin',
      
      // 响应式状态
      isMobile: false,
      resizeTimer: null,

      // 时间状态
      currentTime: '',
      currentDate: '',
      timeTimer: null,

      // 角色状态
      userRolesList: [],
      currentRoleName: '',

      // 保留的原有状态
      selDeptDialogVisible: false,
      selDeptForm: {deptId: null},
      deptOptions: [],
      userinfo: {},
      menuMode: localStorage.getItem('menuMode') || 'tree',
      currentBackground: null,
      contextMenu: {visible: false, position: {x: 0, y: 0}, currentTab: null, currentIndex: -1},
      expireInfo: {show: false, expireDate: null, formattedDate: '', daysRemaining: 0, isExpiringSoon: false},
      editableTabs: [],
      navMenus: []
    }
  },
  computed: {
    headerStyle() {
      if (!this.currentBackground) return {backgroundColor: '#2c4f79', color: '#ffffff'};
      const style = {};
      if (this.currentBackground.type === 'solid') {
        style.backgroundColor = this.currentBackground.color;
        style.color = this.currentBackground.textColor;
      } else {
        style.backgroundImage = `url(${this.currentBackground.url})`;
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
        style.backgroundRepeat = 'no-repeat';
        style.backgroundAttachment = 'fixed';
      }
      return style;
    }
  },
  created() {
    this.initBackground();
    this.initExpireTime();
    this.initTime();
    this.initUserRoles();
    this.initNavMenus();
    this.checkMenuModeConsistency();
  },
  mounted() {
    this.getInstitutionId();
    this.userinfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    this.displayDocName = this.userinfo.clinicName || '九阵数字云诊所';
    this.deptOptions = (this.userinfo.deptDepts || []).map(item => ({id: item.id, label: item.deptName}));
    this.staffName = this.userinfo.staffName || 'admin';

    this.initDeptName();
    this.initUserRoles();

    // 初始化设备检查并监听窗口变化
    this.checkDevice();
    window.addEventListener('resize', this.handleResize);

    this.expireTimer = setInterval(() => {
      this.updateExpireTime();
    }, 60000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    EventBus.$off('update-menu', this.initNavMenus);
    if (this.expireTimer) clearInterval(this.expireTimer);
    if (this.timeTimer) clearInterval(this.timeTimer);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
  },
  methods: {
    // 检查是否为移动端尺寸
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleResize() {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.checkDevice();
      }, 200);
    },
    
    handleHelpCenter() {
      window.open('https://help.nfcis.cn/', '_blank');
    },
    // ========== 时间 ==========
    initTime() {
      this.updateTime();
      this.timeTimer = setInterval(this.updateTime, 1000);
    },
    updateTime() {
      const now = new Date();
      this.currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      this.currentDate = `${now.getFullYear()}年${String(now.getMonth() + 1).padStart(2, '0')}月${String(now.getDate()).padStart(2, '0')}日 ${weeks[now.getDay()]}`;
    },

    // ========== 角色初始化与切换 ==========
    initUserRoles() {
      try {
        const rolesStr = localStorage.getItem('userRoles');
        if (rolesStr) {
          const roles = JSON.parse(rolesStr);
          if (Array.isArray(roles) && roles.length > 0) {
            this.userRolesList = roles;
            this.currentRoleName = roles[0].roleName || roles[0].name || roles[0].label || '未分配角色';
          }
        }
        if (this.userRolesList.length === 0) {
          const fallbackName = this.staffName || '用户';
          const deptName = this.userinfo.deptName || this.userinfo.deptDepts?.[0]?.deptName || '部门';
          this.userRolesList = [{roleName: `${fallbackName} · ${deptName}`}];
          this.currentRoleName = this.userRolesList[0].roleName;
        }
      } catch (e) {
        console.error('获取角色失败:', e);
      }
    },
    handleRoleCommand(role) {
      this.currentRoleName = role.roleName || role.name || role.label || role;
      this.$message.success(`已切换至：${this.currentRoleName}`);
      EventBus.$emit('role-change', role);
    },

    // ========== 原有逻辑 ==========
    initExpireTime() { this.updateExpireTime(); },
    updateExpireTime() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const expireTime = userInfo.clinicExipreTime;
        if (!expireTime) {
          this.expireInfo.show = false;
          return;
        }
        const date = new Date(expireTime);
        this.expireInfo.formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const expireDate = new Date(expireTime);
        expireDate.setHours(0, 0, 0, 0);
        const diffDays = Math.ceil((expireDate - today) / (1000 * 60 * 60 * 24));
        this.expireInfo.daysRemaining = diffDays;
        this.expireInfo.isExpiringSoon = diffDays <= 7;
        this.expireInfo.show = true;
      } catch (error) {
        this.expireInfo.show = false;
      }
    },
    handleModeCommand(command) {
      if (command === 'flow') return;
      this.switchMenuMode(command);
    },
    switchMenuMode(mode) {
      if (this.menuMode === mode) return;
      this.menuMode = mode;
      localStorage.setItem('menuMode', mode);
      EventBus.$emit('menu-mode-change', mode);
      if (mode === 'tree') {
        EventBus.$emit('show-sidebar-menu');
      }
    },
    checkMenuModeConsistency() {
      const savedMode = localStorage.getItem('menuMode');
      if (savedMode && savedMode !== this.menuMode) this.menuMode = savedMode;
    },
    async initNavMenus() {
      try {
        const userinfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const res = await searchUserMenu({username: userinfo.username});
        this.navMenus = this.filterAndBuildMenuTree(res);
        EventBus.$emit('nav-menus-update', this.navMenus);
        if (this.menuMode === 'tree') {
          EventBus.$emit('show-sidebar-menu');
        }
      } catch (error) {
        console.error('获取导航菜单失败:', error);
      }
    },
    filterAndBuildMenuTree(menuData) {
      if (!menuData || !Array.isArray(menuData)) return [];
      return menuData
          .filter(menu => menu.type !== 'F')
          .map(menu => {
            const menuItem = {...menu, children: []};
            if (menu.children && Array.isArray(menu.children)) {
              menuItem.children = this.filterAndBuildMenuTree(menu.children);
            }
            return menuItem;
          })
          .filter(menu => (menu.children && menu.children.length > 0) || (menu.path && menu.path !== ''));
    },
    async clearBrowserCache() {
      try {
        await this.$confirm('确定要清理浏览器缓存吗？', '清理缓存', {type: 'warning'});
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = window.location.href.split('?')[0] + '?_force=' + Date.now();
      } catch (e) {}
    },
    
    // 统一处理下拉菜单事件
    HandleCommand(command) {
      // 处理移动端角色切换
      if (command.startsWith('role-')) {
        const index = parseInt(command.split('-')[1]);
        this.handleRoleCommand(this.userRolesList[index]);
        return;
      }
      // 处理移动端新增命令
      if (command === 'help') {
        this.handleHelpCenter();
        return;
      }
      if (command === 'menuTree') {
        this.handleModeCommand('tree');
        this.$message.success('已切换至菜单树模式');
        return;
      }

      // 通用命令
      if (command === 'userinfo') {
        this.$router.push('/profile');
      } else if (command === 'changeDept') {
        this.selDeptDialogVisible = true;
      } else if (command === 'clearCache') {
        this.clearBrowserCache();
      } else if (command === 'loginout') {
        this.getAginLogin();
      }
    },
    async getAginLogin() {
      let res = await loginOut();
      if (res.code === 200) {
        watermark.clear();
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push('/login');
      }
    },
    initBackground() {
      const savedBg = localStorage.getItem('appBackground');
      if (savedBg) {
        this.currentBackground = JSON.parse(savedBg);
      } else {
        this.currentBackground = {title: '默认深蓝', color: '#2c4f79', textColor: '#ffffff', type: 'solid'};
        localStorage.setItem('appBackground', JSON.stringify(this.currentBackground));
      }
    },
    initDeptName() {
      if (this.userinfo.selDept) {
        const dept = this.deptOptions.find(d => d.id === this.userinfo.selDept);
        this.depeName = dept?.label || '';
        return;
      }
      if (this.deptOptions.length === 1) {
        this.selDeptForm.deptId = this.deptOptions[0].id;
        this.depeName = this.deptOptions[0].label;
        this.handleChekedDept();
      } else if (this.deptOptions.length > 1) {
        this.selDeptDialogVisible = true;
      }
    },
    async handleChekedDept() {
      if (!this.selDeptForm.deptId) {
        this.$message.error("请选择科室!");
        return;
      }
      try {
        const dept = this.deptOptions.find(item => item.id === this.selDeptForm.deptId);
        if (!dept) throw new Error('科室不存在');
        this.depeName = dept.label;
        const userInfo = {...JSON.parse(localStorage.getItem('userInfo') || '{}'), selDept: this.selDeptForm.deptId};
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.selDeptDialogVisible = false;
        EventBus.$emit('dept-change', dept.label);
      } catch (error) {
        this.$message.error(error.message || '保存科室信息失败');
      }
    },
    handleBeforeClose() {
      this.selDeptDialogVisible = false;
    },
    async getInstitutionId() {
      try {
        let res = await docclinic();
        if (res.data) {
          this.visibleClinicCount = res.data.length;
        }
      } catch (e) {
        console.error('获取诊所数量失败');
      }
    },
    hideContextMenu() {},
    handleCloseCurrent() {},
    handleCloseRight() {},
    handleCloseLeft() {},
    handleCloseAll() {}
  }
}
</script>

<style lang="less" scoped>
.header {
  background-color: #2c4f79;
  color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  height: auto;
  min-height: 60px;
  flex-shrink: 0;
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(44, 79, 121, 0.9);
    z-index: -1;
  }

  .top {
    position: relative;
    z-index: 1;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    transition: all 0.3s ease;

    /* ===== 左容器 ===== */
    .left-container {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      white-space: nowrap;
      min-width: 0;

      .logo-and-expire {
        display: flex;
        align-items: center;

        .logo-part {
          display: flex;
          align-items: center;

          .app-title {
            font-size: 18px;
            font-weight: 500;
            display: flex;
            align-items: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            i {
              color: rgba(255, 255, 255, 0.9);
            }
          }
        }

        .expire-part {
          margin-left: 12px;
          display: flex;
          align-items: center;

          .expire-days {
            font-size: 12px;
            white-space: nowrap;
            padding: 2px 6px;
            border-radius: 12px;
            background: rgba(64, 158, 255, 0.2);
            color: #ffffff;

            &.expire-warning {
              background: rgba(245, 108, 108, 0.25);
              color: #f56c6c;
              animation: pulse 1.5s infinite;
            }
          }
        }
      }
    }

    /* ===== 中间容器 ===== */
    .time-container {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      .time-display {
        display: flex;
        flex-direction: column;
        align-items: center;

        .time {
          font-size: 20px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 1.2;
        }

        .date {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 2px;
        }
      }
    }

    /* ===== 右容器 ===== */
    .right-container {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;

      .role-dropdown {
        .role-btn {
          display: inline-flex;
          align-items: center;
          padding: 6px 12px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 4px;
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.3s;
          white-space: nowrap;

          &:hover {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }

      .mode-dropdown {
        .mode-button {
          display: inline-flex;
          align-items: center;
          padding: 6px 12px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 4px;
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
          font-size: 13px;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.3s;

          i {
            margin-right: 4px;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }

      .user-info {
        .el-dropdown-link {
          display: flex;
          align-items: center;
          color: #ffffff;
          font-weight: 500;
          cursor: pointer;

          .user-avatar {
            background-color: #c0a080;
            color: #fff;
            font-size: 14px;
            flex-shrink: 0;
          }

          .mobile-arrow {
            font-size: 12px;
          }

          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }

  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.6; }
    100% { opacity: 1; }
  }

  /* =========================================================
     多端响应式适配
     ========================================================= */
  
  /* 平板尺寸 */
  @media (max-width: 992px) {
    .top {
      padding: 0 16px;
      .time-container .time-display .time { font-size: 18px; }
      .right-container { gap: 12px; }
    }
  }

  /* 手机端尺寸：隐藏独立按钮，收缩布局 */
  @media (max-width: 768px) {
    min-height: 50px;
    
    .top {
      height: 50px;
      padding: 0 12px;
      flex-wrap: wrap;
    }

    .left-container {
      flex: 1;
      min-width: 0;
      margin-right: 8px;
      
      .logo-and-expire {
        .logo-part .app-title {
          font-size: 15px;
          max-width: 140px;
          i {
            font-size: 20px !important;
            margin-right: 4px !important;
          }
        }
        .expire-part {
          display: none;
        }
      }
    }

    .time-container {
      display: none;
    }

    .right-container {
      gap: 8px;

      /* ★ 关键：在手机端隐藏独立的 PC 端专属按钮 */
      .pc-only {
        display: none !important;
      }

      /* 用户信息轻量化 */
      .user-info .el-dropdown-link {
        .user-avatar {
          margin-right: 0 !important;
          width: 28px !important;
          height: 28px !important;
        }
        .user-name {
          display: none;
        }
        .mobile-arrow {
          margin-left: 4px;
        }
      }
    }
  }

  /* 极窄屏幕（如 iPhone SE） */
  @media (max-width: 480px) {
    .top {
      padding: 0 8px;
    }
    
    .left-container .logo-and-expire .logo-part .app-title {
      font-size: 14px;
      max-width: 110px;
      i { font-size: 18px !important; }
    }
  }
}
</style>

<style lang="less">
/* 全局覆盖：让移动端的下拉菜单项标题带点样式 */
.dropdown-group-title {
  font-size: 12px !important;
  color: #909399 !important;
  padding-top: 8px !important;
  padding-bottom: 4px !important;
  line-height: 1.2 !important;
  cursor: default !important;
}
</style>